import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='brokerage-accounts-services'
      advisorImageVariant='advisorB'
      headingText={<>Ready to open a <WidowBlock>brokerage account&#63;</WidowBlock></>}
      text='Our financial advisors will set up your brokerage account and help you find the right investments to take you where you want to go.'
    />
  );
};
